<template>
    <div class="page-table tabStyle mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.urun.kategori.tanimlama.baslikH1")}}
        </div>
        <el-row :gutter="10">
            <el-form status-icon :model="urunKategoriForm" :rules="rulesUrunKategori" ref="urunKategoriForm"
                     class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.baslik")'
                                                      prop="baslik">:
                                            <div v-if="linkVisible" style="float: right; display: flex">
                                                <div v-if="!VisibleA">
                                                    <el-link target="_blank" :underline="false"
                                                             :href="path">
                                                        {{this.path}}{{this.urunKategoriForm.link}}
                                                    </el-link>
                                                </div>
                                                <el-button v-if="duzenleBtnVisible"
                                                           style="margin-left: 10px; margin-bottom: 5px"
                                                           v-on:click="VisibleA = true;  duzenleBtnVisible=false"
                                                           size="mini">Düzenle
                                                </el-button>
                                                <span v-if="VisibleA">{{this.path}} </span>
                                                <el-input size="mini"  v-if="VisibleA" v-model="urunKategoriForm.link"
                                                          v-on:change="linkChange = false"
                                                          v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                          style="width: 50%" ></el-input>
                                            </div>
                                            <el-input size="small"
                                                      v-model="urunKategoriForm.baslik"
                                                      v-on:change="linkTespit"
                                                      v-on:input="linkTespit"
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik")'
                                                      prop="altBaslik">:
                                            <el-input size="small"
                                                      v-model="urunKategoriForm.altBaslik"
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik")'
                                                      prop="icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunKategoriForm.icerik"
                                                      @input="seoIcerikTespit"
                                                      @blur="seoIcerikTespit"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Resim (800x600)'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item class="card-shadow--medium" title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                          prop="seoBaslik">:
                                                <el-input size="small"
                                                          v-model="urunKategoriForm.seoBaslik"
                                                          maxlength="60"
                                                          show-word-limit
                                                          :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                          prop="seoIcerik">:
                                                <el-input size="small"  type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikChange = false"
                                                          show-word-limit
                                                          v-model="urunKategoriForm.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-de"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.baslik") + "(Almanca)"'
                                                      prop="dil.de.baslik">:
                                            <el-input size="small"
                                                      v-model="urunKategoriForm.dil.de.baslik"
                                                      v-on:input="urunKategoriForm.dil.de.seoBaslik=urunKategoriForm.dil.de.baslik.substring(0, 60)"
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik") + "(Almanca)"'
                                                      prop="dil.de.altBaslik">:
                                            <el-input size="small"
                                                      v-model="urunKategoriForm.dil.de.altBaslik"
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik") + "(Almanca)"'
                                                      prop="dil.de.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunKategoriForm.dil.de.icerik"
                                                      @input="seoIcerikDETespit"
                                                      @blur="seoIcerikDETespit"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Resim (800x600)'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item class="card-shadow--medium" title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik") + "(Almanca)"'
                                                          prop="dil.de.seoBaslik">:
                                                <el-input size="small"
                                                          v-model="urunKategoriForm.dil.de.seoBaslik"
                                                          maxlength="60"
                                                          show-word-limit
                                                          :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik") + "(Almanca)"'
                                                          prop="dil.de.seoIcerik">:
                                                <el-input size="small"  type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikDEChange = false"
                                                          show-word-limit
                                                          v-model="urunKategoriForm.dil.de.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.baslik") + "(İngilizce)"'
                                                      prop="dil.en.baslik">:
                                            <el-input size="small"
                                                      v-model="urunKategoriForm.dil.en.baslik"
                                                      v-on:input="urunKategoriForm.dil.en.seoBaslik=urunKategoriForm.dil.en.baslik.substring(0, 60)"
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik") + "(İngilizce)"'
                                                      prop="dil.en.altBaslik">:
                                            <el-input size="small"
                                                      v-model="urunKategoriForm.dil.en.altBaslik"
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik") + "(İngilizce)"'
                                                      prop="dil.en.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunKategoriForm.dil.en.icerik"
                                                      @input="seoIcerikENTespit"
                                                      @blur="seoIcerikENTespit"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item label='Resim (800x600)'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item class="card-shadow--medium" title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik") + "(İngilizce)"'
                                                          prop="dil.en.seoBaslik">:
                                                <el-input size="small"
                                                          v-model="urunKategoriForm.dil.en.seoBaslik"
                                                          maxlength="60"
                                                          show-word-limit
                                                          :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik") + "(İngilizce)"'
                                                          prop="dil.en.seoIcerik">:
                                                <el-input size="small"  type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikENChange = false"
                                                          show-word-limit
                                                          v-model="urunKategoriForm.dil.en.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.haberler.tanimlama.durum")'>
                            <el-row>
                                <el-button
                                        style="margin-bottom: 10px"
                                        size="mini" v-on:click="kategoriGuncelle('urunKategoriForm')"
                                        class="onayBtn"
                                        type="primary">
                                    {{$t('src.views.apps.haberler.guncelleme.haberGuncelle')}}
                                </el-button>
                            </el-row>
                            <el-row>
                                <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                    <el-form-item class="margin-top-10">
                                        <el-button size="mini" type="success" v-on:click="iconListDialog = true"
                                                   icon="el-icon-search">İcon Seç
                                        </el-button>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p" >
                                    <el-form-item>
                                        <el-color-picker style="float: right" v-model="urunKategoriForm.renk"></el-color-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item class="card-shadow--medium"
                                          :title='$t("src.views.apps.urun.kategori.tanimlama.ustKategori")' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="ustKategori">
                                        <el-tree
                                                :data="treeList"
                                                @node-click="handleNodeClick"
                                                node-key="id"
                                                icon-class
                                                :props="defaultProps">
                                        </el-tree>
                                    </el-form-item>
                                    <el-button style="float: right" type="text" v-on:click="ustKatTemizle">Üst Kategori Temizle</el-button>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                </el-col>
            </el-form>
            <el-dialog
                    :title='$t("src.views.apps.rakamlar.islem.iconList")'
                    :visible.sync="iconListDialog"
                    width="60%"
                    center>
                <div>
                    <el-row class="iconRow">
                        <el-col v-for="(item,index) in iconListe"
                                :key="item"
                                :label="item"
                                :value="item" :lg="4" :md="4" :sm="8" :xs="8"
                                style="border: 1px solid #9a9a9a; padding: 5px; height: 100px; text-align: center;display:table">
                            <div v-on:click="iconSelect(item)" class="iconCerceve" id="#iconCerceve">
                                <el-button type="text">
                                    <i style="font-size: 24px;text-align: center" :class="item"></i>
                                </el-button>
                                <br>
                                <span class="icon-name" :data-class="item">{{item}}</span>
                            </div>
                        </el-col>
                    </el-row>

                </div>
            </el-dialog>
            <el-dialog
                    title='Sunucudan Fotoğraf Seç'
                    :visible.sync="dialogImgServerVisible"
                    width="60%"
                    center>
                <el-upload
                        action="#"
                        accept=".jpg,.jpeg,.png"
                        :on-change="serverImageUpload"
                        list-type="picture-card"
                        :file-list="imageListServer"
                        :auto-upload="false">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                        <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-delete"
                                  @click="imageUploadtoServer(file)">
                                  <i class="el-icon-plus"></i>
                            </span>
                        </span>
                    </div>
                </el-upload>
            </el-dialog>
        </el-row>
    </div>
</template>

<script>
    import JQuery from 'jquery';
    import ClassicEditor from '../../../../../node_modules/ckeditor5-build-classic';
    import iconJson from '../../../../icon'
    import '@fortawesome/fontawesome-free/css/all.css'
    import '@fortawesome/fontawesome-free/js/all.js'
    import urunService from '../../../../WSProvider/UrunService'
    import seoService from '../../../../WSProvider/SeoService'
    import controllerService from '../../../../WSProvider/ControllerService'
    import notification from '../../../../notification'
    import functions from '../../../../functions'
    import EventBus from '@/components/event-bus'

    let $ = JQuery;
    export default {
        name: "KategoriDuzenle",
        components: {},
        mounted() {
            this.getTreeList();
            this.updateKategoriKodu = this.$store.state.updateKodu;
            this.getKategoriDetay(this.updateKategoriKodu);
        },
        data() {
            return {
                iconListDialog: false,
                iconListe: iconJson["v5.0.9"],
                checkedKeysKategori: [],
                path: urunService.path,
                updateKategoriKodu: '',
                kategoriDetayKlon: [],
                imageLogo: [],
                updateData: [],
                updateDataDE: [],
                updateDataEN: [],
                imageListServer: [],
                fileListServer: [],
                opsiyonListesi: [],
                dialogImgServerVisible: false,
                dialogDocServerVisible: false,
                seoIcerikChange: true,
                seoIcerikDEChange: true,
                seoIcerikENChange: true,
                VisibleA: false,
                linkChange: true,
                linkVisible: false,
                duzenleBtnVisible: true,
                imageListMain: [],
                orjinalResimList: [],
                fileListMain: [],
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },
                activeCollapse: ['1', '2', '3', '4', '5'],
                visibleSil: false,
                checked: true,
                treeList: [],
                defaultProps: {
                    id: 'id',
                    children: 'children',
                    label: 'name'
                },
                urunKategoriForm: {
                    baslik: "",
                    altBaslik: "",
                    icerik: "",
                    link: '',
                    kapak: '',
                    ustKategori: '',
                    seoBaslik: '',
                    seoIcerik: '',
                    resim: [],
                    opsiyonList: [],
                    durum: "1",
                    icon: '',
                    renk: '',
                    dil: {
                        de: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: '',
                        },
                        en: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: '',
                        },
                    }
                },
                rulesUrunKategori: {
                    baslik: [{
                        required: true,
                        message: " ",
                        trigger: 'change'
                    }],
                    musteri: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            handleNodeClick(data) {
                this.urunKategoriForm.ustKategori = data.id;
            },
            ustKatTemizle() {
                $(".el-tree-node").removeClass("is-current");
                this.urunKategoriForm.ustKategori = [];
            },
            getTreeList() {

                urunService.kategoriTree().then((response) => {
                    if (response.status === 200) {
                        this.treeList = response.data;
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
            linkTespitLink() {
                let self = this;
                if (this.urunKategoriForm.link) {
                    seoService.linkKontrol(self.urunKategoriForm.link.replace("'", "")).then((response) => {
                        if (response.status === 200) {
                            self.urunKategoriForm.link = response.data;
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.linkChange) {
                    seoService.linkKontrol(self.urunKategoriForm.baslik.replace("'", "")).then((response) => {
                        if (response.status === 200) {
                            if (self.urunKategoriForm.baslik) {
                                self.urunKategoriForm.seoBaslik = self.urunKategoriForm.baslik.substring(0, 60);
                                if (response.status === 200) {
                                    self.linkVisible = true;
                                    self.urunKategoriForm.link = response.data;
                                }
                            } else if (!self.urunKategoriForm.baslik) {
                                self.linkVisible = false;
                                self.urunKategoriForm.link = '';
                                self.urunKategoriForm.seoBaslik = '';
                            }
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            seoIcerikTespit() {
                if (this.seoIcerikChange) {
                    const myStr = functions.strip_html_tags(this.urunKategoriForm.icerik);
                    this.urunKategoriForm.seoIcerik = myStr.substring(0, 140);
                }
            },
            seoIcerikDETespit() {
                if (this.seoIcerikDEChange && this.urunKategoriForm.dil.de.icerik) {
                    const myStr = functions.strip_html_tags(this.urunKategoriForm.dil.de.icerik);
                    this.urunKategoriForm.dil.de.seoIcerik = myStr.substring(0, 140);
                }else this.urunKategoriForm.dil.de.seoIcerik = '';
            },
            seoIcerikENTespit() {
                if (this.seoIcerikENChange && this.urunKategoriForm.dil.en.icerik) {
                    const myStr = functions.strip_html_tags(this.urunKategoriForm.dil.en.icerik);
                    this.urunKategoriForm.dil.en.seoIcerik = myStr.substring(0, 140);
                }else this.urunKategoriForm.dil.en.seoIcerik = '';
            },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, randomText(13) + '-' + file.name);
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            serverImageList() {
                var dizi = [];
                controllerService.sunucuResim("urunKategori").then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                                url: urunService.imageUrlKucuk + e
                            };
                            dizi.push(item);
                        });
                        this.imageListServer = dizi;
                    }
                })
            },
            imageUploadtoServer(file) {
                if (this.imageListMain.length === 0) {
                    var item = {
                        name: file.name,
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                } else {
                    let obj = this.imageListMain.find(data => data.name === file.name.slice(file.name.indexOf("-") + 1));
                    if (obj === undefined) {
                        item = {
                            name: file.name,
                            url: file.url,
                        };
                        this.imageListMain.push(item);
                        notification.Status('success', this, file.name.slice(file.name.indexOf("-") + 1) + ' resmi eklendi.');
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
            },
            sumResimFonkLogo(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('kapak', imgname, data).then((response) => {
                            if (response.status === 200) {
                                this.urunKategoriForm.kapak = response.data[0].file;
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('urunKategori', imgname, data).then((response) => {
                            if (response.status === 200) {
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            logoUpload(file, fileList) {
                $('.logo .el-upload--picture-card').hide();
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.urunKategoriForm.baslik) {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            var imgname = "kapak-" + functions.randomText(7) + '-' + functions.linkTemizle(this.urunKategoriForm.baslik) + ".jpg";
                        } else {
                            imgname = "kapak-" + functions.randomText(7) + '-' + functions.linkTemizle(this.urunKategoriForm.baslik) + ".png";
                        }
                    } else {
                        if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg') {
                            imgname = "kapak-" + functions.randomText(7) + '-' + functions.linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".jpg";
                        } else {
                            imgname = "kapak-" + functions.randomText(7) + '-' + functions.linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                        }
                    }
                    this.sumResimFonkLogo(file, imgname);
                } else {
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            logoRemove() {
                this.urunKategoriForm.logo = "";
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.urunKategoriForm.baslik) {
                        var imgname = randomText(7) + '-' + this.urunKategoriForm.link + ".png";
                    } else {
                        imgname = randomText(7) + '-' + linkTemizle(file.name.split('.')[0]) + ".png";
                    }
                    if (this.imageListMain.length === 0) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.imageListMain.push(item);
                        this.sumResimFonk(file, imgname);
                    } else {
                        let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                        if (obj === undefined) {
                            item = {
                                name: imgname,
                                url: file.url,
                                id: file.raw.lastModified
                            };
                            this.imageListMain.push(item);
                            this.sumResimFonk(file, imgname);
                        } else {
                            notification.Status('warning', this, 'Bu resim zaten mevcut');
                        }
                    }
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.imageListMain = [];
                this.fileListMain = [];
                this.urunKategoriForm.link = null;
                this.linkVisible = false;
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "KategoriDuzenle");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "KategoriDuzenle") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
            getKategoriDetay() {
                let self = this;
                urunService.ukategoriDetay(this.updateKategoriKodu).then((response) => {
                    if (response.status === 200) {
                        self.linkVisible = true;
                        if (response.data.anaResim) {
                            self.orjinalResimList.push(response.data.anaResim);
                            self.imageListMain.push({
                                name: response.data.anaResim,
                                url: urunService.imageUrlOrta + response.data.anaResim
                            });
                        }
                        if (response.data['resim']) {
                            response.data['resim'].forEach(function (e) {
                                if (e) {
                                    self.orjinalResimList.push(e);
                                    self.imageListMain.push({
                                        name: e,
                                        url: urunService.imageUrlOrta + e
                                    });
                                }
                            });
                        }
                        if (response.data.kategori) {
                            this.urunKategoriForm.ukategoriId = response.data.ukategoriId;
                            this.checkedKeysKategori.push( response.data.ukategoriId )
                            // response.data.kategori.forEach(function (e) {
                            //     self.urunForm.kategori.push(e.ukategoriKodu)
                            //     self.checkedKeysKategori.push( e.ukategoriKodu )
                            // })
                            this.$nextTick(() => {
                                this.$refs.tree.setCheckedKeys(self.checkedKeysKategori);
                            });
                        }
                        this.urunKategoriForm.baslik = response.data.baslik;
                        this.urunKategoriForm.altBaslik = response.data.altBaslik;
                        if (response.data.link) {
                            this.urunKategoriForm.link = response.data.link;
                            this.linkVisible = true
                        }
                        if (response.data.icerik) {
                            this.urunKategoriForm.icerik = htmlDecode(response.data.icerik);
                        }
                        this.urunKategoriForm.seoBaslik = response.data.seoBaslik;
                        this.urunKategoriForm.seoIcerik = response.data.seoIcerik;
                        this.urunKategoriForm.renk = response.data.renk;
                        this.urunKategoriForm.icon = response.data.icon;
                        this.urunKategoriForm.durum = response.data.durum;
                        if (response.data.dil.de) {
                            self.urunKategoriForm.dil.de.baslik = response.data.dil.de.baslik;
                            self.urunKategoriForm.dil.de.altBaslik = response.data.dil.de.altBaslik;
                            self.urunKategoriForm.dil.de.seoBaslik = response.data.dil.de.seoBaslik;
                            self.urunKategoriForm.dil.de.seoIcerik = response.data.dil.de.seoIcerik;
                            if (response.data.dil.de.icerik) {
                                self.urunKategoriForm.dil.de.icerik = functions.htmlDecode(response.data.dil.de.icerik);
                            }
                        }
                        if (response.data.dil.en) {
                            self.urunKategoriForm.dil.en.baslik = response.data.dil.en.baslik;
                            self.urunKategoriForm.dil.en.altBaslik = response.data.dil.en.altBaslik;
                            self.urunKategoriForm.dil.en.seoBaslik = response.data.dil.en.seoBaslik;
                            self.urunKategoriForm.dil.en.seoIcerik = response.data.dil.en.seoIcerik;
                            if (response.data.dil.en.icerik) {
                                self.urunKategoriForm.dil.en.icerik = functions.htmlDecode(response.data.dil.en.icerik);
                            }
                        }
                        this.kategoriDetayKlon = response.data;
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
            kategoriGuncelle(formName) {
                let self = this;
                for (var key in this.kategoriDetayKlon) {
                    if (key !== 'resim' &&  key !== 'belge' && key !== 'dil') {
                        if (this.kategoriDetayKlon[key] !== this.urunKategoriForm[key]) {
                            if (this.urunKategoriForm[key]) {
                                var item = {
                                    type: key,
                                    value: this.urunKategoriForm[key]
                                };
                                this.updateData.push(item);
                            }
                        }
                    } else if (key === "resim") {
                        if (self.imageListMain.length === 0) {
                            if (self.orjinalResimList.length > 0) {
                                self.orjinalResimList.forEach(function (e) {
                                    updateListImage(self, 'resim', 0, e);
                                })
                            }
                        } else {
                            for (var i = 0; i < self.imageListMain.length; i++) {
                                if (i === 0) {
                                    if (self.imageListMain[0].name !== self.orjinalResimList[0]) {
                                        updateListImage(self, 'resim', 2, self.imageListMain[0].name);
                                        let obj = self.imageListMain.find(data => data.name === self.orjinalResimList[0]);
                                        if (obj !== undefined) {
                                            updateListImage(self, 'resim', 1, self.orjinalResimList[0]);
                                        }
                                    }
                                } else {
                                    let obj = self.orjinalResimList.find(data => data === self.imageListMain[i].name);
                                    if (obj === undefined) {
                                        updateListImage(self, 'resim', 1, self.imageListMain[i].name);
                                    }
                                }
                            }
                            if (self.orjinalResimList.length > 0) {
                                for (var y = 1; y < self.orjinalResimList.length; y++) {
                                    let obj = self.imageListMain.find(data => data.name === self.orjinalResimList[y]);
                                    if (obj === undefined) {
                                        updateListImage(self, 'resim', 0, self.orjinalResimList[y]);
                                    }
                                }
                            }
                        }
                    }else if (key === 'dil') {
                        for (var keyDil in this.kategoriDetayKlon.dil.de) {
                            if (this.kategoriDetayKlon.dil.de[keyDil] !== this.urunKategoriForm.dil.de[keyDil]) {
                                if (this.urunKategoriForm.dil.de[keyDil]) {
                                    var itemDe = {
                                        type: keyDil,
                                        value: this.urunKategoriForm.dil.de[keyDil]
                                    };
                                    this.updateDataDE.push(itemDe);
                                }
                            }
                        }
                        for (var keyDil2 in this.kategoriDetayKlon.dil.en) {
                            if (this.kategoriDetayKlon.dil.en[keyDil2] !== this.urunKategoriForm.dil.en[keyDil2]) {
                                if (this.urunKategoriForm.dil.en[keyDil2]) {
                                    var itemEn = {
                                        type: keyDil2,
                                        value: this.urunKategoriForm.dil.en[keyDil2]
                                    };
                                    this.updateDataEN.push(itemEn);
                                }
                            }
                        }
                        if (this.updateDataDE.length !== 0 || this.updateDataEN.length !== 0 ) {
                            this.updateData.push({
                                type: "dil",
                                value: {
                                    de: this.updateDataDE,
                                    en: this.updateDataEN,
                                }
                            })
                        }
                    }
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (valid && this.updateData.length !== 0) {
                            urunService.ukategoriGuncelle(this.updateKategoriKodu, this.updateData).then((response) => {
                                if (response.status === 200) {
                                    notification.Status('success', this, 'Kategori başarıyla güncellendi.');
                                    this.resetForm(formName);
                                    EventBus.$emit("ukategoriList", true)

                                    $('.el-upload-list__item-delete').click();
                                }
                                if (response.status === 230) {
                                    notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir kategori zaten mevcut');

                                } else {
                                    notification.Status(response.status, this)
                                }
                            })
                        }

                    }
                })
            },
        }
    }
    function updateListImage(self, type, durum, name) {
        var item = {
            type: type,
            value: [{
                durum: durum,
                [type]: name
            }]
        };
        self.updateData.push(item);
    }
    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")
            .toLowerCase();

    }

    function htmlDecode(input) {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes[0].nodeValue;
    }

    function strip_html_tags(str) {
        str = str.replace(/&nbsp;/gi, '');
        if ((str === null) || (str === ''))
            return false;
        else
            str = str.toString();
        return str.replace(/<[^>]*>/g, '');
    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }
</script>

<style lang="scss" scoped>
    @import '../../../../assets/scss/_variables';

    .aciklamaSpan {
        position: absolute;
        top: 25px;
    }

    .page-table {
        &.overflow {
            overflow: hidden;
        }

        .table-box {
            overflow: hidden;
        }
    }

    .el-form-item {
        font-weight: bold;
    }

</style>
